export default "__VITE_ASSET__CgYU5Ark__"